import { render, staticRenderFns } from "./afterOrderList.vue?vue&type=template&id=54ba2786&scoped=true"
import script from "./afterOrderList.vue?vue&type=script&lang=js"
export * from "./afterOrderList.vue?vue&type=script&lang=js"
import style0 from "./afterOrderList.vue?vue&type=style&index=0&id=54ba2786&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba2786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ba2786')) {
      api.createRecord('54ba2786', component.options)
    } else {
      api.reload('54ba2786', component.options)
    }
    module.hot.accept("./afterOrderList.vue?vue&type=template&id=54ba2786&scoped=true", function () {
      api.rerender('54ba2786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderManagement/afterOrderList/afterOrderList.vue"
export default component.exports